import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Prima di YOGA PRO™ passavo le mie domeniche pomeriggio a cercare ispirazione su Instagram e a scrivere sequenze su foglietti volanti. Ora ho un sistema che mi permette di preparare una settimana di classi in 15 minuti. Le mie allieve hanno notato subito il salto di qualità.',
  author: 'Elena M.',
  role: 'Insegnante Vinyasa',
  location: 'Milano'
}, {
  text: "Lavoro molto con persone anziane e con problemi posturali. Il modulo 'Yoga Posturale e Benessere della Schiena' vale da solo 10 volte il prezzo del pacchetto. Le modificazioni sono precise e sicure. Finalmente insegno senza l'ansia di fare danni.",
  author: 'Silvia R.',
  role: 'Istruttrice Yoga Terapeutico',
  location: 'Roma'
}, {
  text: "Avevo appena finito il mio corso 200 ore e mi sentivo persa. Non sapevo come strutturare una classe di 60 minuti che avesse senso. Questo sistema mi ha dato la struttura e la sicurezza che mi mancavano. La 'Banca di Intro e Chiusure' è geniale.",
  author: 'Chiara F.',
  role: 'Nuova Insegnante',
  location: 'Torino'
}, {
  text: "Insegno da 8 anni e stavo vivendo un forte burnout creativo. Le mie classi erano diventate noiose e ripetitive. Le 'Lezioni Tematiche e Stagionali' hanno riportato energia nel mio studio. Ho anche usato una delle Masterclass per un evento domenicale che ha fatto sold-out.",
  author: 'Martina L.',
  role: 'Proprietaria di Studio',
  location: 'Bologna'
}, {
  text: "Il 'Planner Settimanale' e la 'Matrice di Scelta Rapida' hanno cambiato il mio modo di lavorare. Sostituisco spesso colleghi all'ultimo minuto e ora so esattamente cosa proporre in base al livello della classe, senza stress e con grande professionalità.",
  author: 'Giulia C.',
  role: 'Insegnante Freelance',
  location: 'Firenze'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-white border-b-8 border-brand-light" data-id="element-163">
      <div className="max-w-5xl mx-auto" data-id="element-164">
        <div className="text-center mb-12" data-id="element-165">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-dark mb-4 tracking-tight uppercase" data-id="element-166">
            COSA DICONO LE NOSTRE INSEGNANTI
          </h2>
          <p className="text-base sm:text-lg font-bold text-brand-green uppercase tracking-widest" data-id="element-167">
            Storie di successo reali
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-168">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-light border-2 border-brand-green/20 p-8 rounded-xl shadow-lg relative hover:border-brand-green transition-colors" data-id="element-169">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-brand-green/20" data-id="element-170" />
              <div className="flex gap-1 mb-4" data-id="element-171">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-172" />)}
              </div>
              <p className="text-brand-dark/90 font-medium mb-8 leading-relaxed italic text-base sm:text-lg relative z-10" data-id="element-173">
                "{t.text}"
              </p>
              <div className="border-t-2 border-brand-green/10 pt-6 flex items-center gap-4" data-id="element-174">
                <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center text-white font-black text-xl shadow-md" data-id="element-175">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-176">
                  <p className="font-black text-brand-dark text-base uppercase" data-id="element-177">
                    {t.author}
                  </p>
                  <p className="text-xs sm:text-sm text-brand-dark/60 font-bold uppercase tracking-wider mt-1" data-id="element-178">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}